/* SABER · capa cinematografica · Jorge Blaisdell · Medical Mentor */
(function saberJB(){
  "use strict";

  var cfg  = window.JB_SABER || {};
  var foto = cfg.foto || "jb-14-extra.webp";
  var tipo = cfg.tipo || "articulo";
  var velo = (typeof cfg.velo === "number") ? cfg.velo : 1;
  var base = cfg.base || "https://cdn.shopify.com/s/files/1/0717/8276/0627/files/";

  var html = document.documentElement;

  function montaEscena(){
    if (document.getElementById("jb-escena")) return;
    html.setAttribute("data-saber", tipo);

    var esc = document.createElement("div");
    esc.id = "jb-escena";
    esc.setAttribute("aria-hidden", "true");

    var img = document.createElement("div");
    img.className = "jb-foto";
    img.style.backgroundImage = "url('" + base + foto + "')";

    var velow = document.createElement("div");
    velow.className = "jb-velo-w";
    velow.style.setProperty("--jb-velo", String(velo));

    var v = document.createElement("div");
    v.className = "jb-velo";
    velow.appendChild(v);

    var luz = document.createElement("div");
    luz.className = "jb-luzbaja";

    var gr = document.createElement("div");
    gr.className = "jb-grano";

    esc.appendChild(img);
    esc.appendChild(velow);
    esc.appendChild(luz);
    esc.appendChild(gr);

    document.body.insertBefore(esc, document.body.firstChild);
  }

  function marcaApariciones(){
    var lista = [];
    if (tipo === "indice"){
      lista = Array.prototype.slice.call(
        document.querySelectorAll(".articles-grid .article-card")
      );
    } else {
      var cont = document.querySelector("article.body .container");
      if (cont){
        lista = Array.prototype.slice.call(cont.children).filter(function(el){
          return /^(P|H2|H3|H4|UL|OL|BLOCKQUOTE|FIGURE|DIV)$/.test(el.tagName);
        });
      }
    }
    lista.forEach(function(el){
      if (el.classList.contains("reveal-fade")) return;
      if (el.classList.contains("reveal-up")) return;
      if (el.classList.contains("reveal-blur")) return;
      el.classList.add("jb-aparece");
    });

    if (tipo === "articulo"){
      var c = document.querySelector("article.body .container");
      if (c){
        var p = c.querySelector("p");
        if (p && p.innerText.trim().length > 120) p.classList.add("jb-capitular");
      }
    }
  }

  function luzDelCursor(){
    if (tipo !== "indice") return;
    if (window.matchMedia("(hover: none)").matches) return;
    var cards = document.querySelectorAll(".articles-grid .article-card");
    Array.prototype.forEach.call(cards, function(card){
      card.addEventListener("mousemove", function(e){
        var r = card.getBoundingClientRect();
        card.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100).toFixed(1) + "%");
        card.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100).toFixed(1) + "%");
      }, { passive: true });
    });
  }

  function respaldoApariciones(){
    var soporta = window.CSS && CSS.supports && CSS.supports("animation-timeline", "view()");
    if (soporta) return;
    if (!window.IntersectionObserver) return;
    var els = document.querySelectorAll(".jb-aparece");
    Array.prototype.forEach.call(els, function(el){
      el.style.opacity = "0";
      el.style.transform = "translateY(38px)";
      el.style.transition = "opacity 720ms cubic-bezier(.2,.7,.3,1), transform 860ms cubic-bezier(.2,.7,.3,1)";
    });
    var io = new IntersectionObserver(function(entradas){
      entradas.forEach(function(en){
        if (!en.isIntersecting) return;
        en.target.style.opacity = "1";
        en.target.style.transform = "none";
        io.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.06 });
    Array.prototype.forEach.call(els, function(el){ io.observe(el); });
  }

  function respaldoCine(){
    var soporta = window.CSS && CSS.supports && CSS.supports("animation-timeline", "scroll(root block)");
    if (soporta) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var f = document.querySelector("#jb-escena .jb-foto");
    var v = document.querySelector("#jb-escena .jb-velo");
    if (!f) return;
    var pend = false;
    function pinta(){
      pend = false;
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var p = alto > 0 ? Math.min(1, Math.max(0, window.scrollY / alto)) : 0;
      var s = 1.04 + p * 0.26;
      var x = (p < 0.55 ? -1.1 * (p / 0.55) : -1.1 + 1.7 * ((p - 0.55) / 0.45));
      var y = -2.6 * p;
      f.style.transform = "scale(" + s.toFixed(4) + ") translate3d(" + x.toFixed(2) + "%," + y.toFixed(2) + "%,0)";
      if (v) v.style.opacity = String(0.78 + 0.22 * Math.sin(Math.PI * Math.min(1, p * 1.1)));
    }
    window.addEventListener("scroll", function(){
      if (!pend){ pend = true; requestAnimationFrame(pinta); }
    }, { passive: true });
    window.addEventListener("resize", pinta, { passive: true });
    pinta();
  }

  function montaSalidas(){
    var nav = document.querySelector(".doc-nav");
    if (nav && !nav.querySelector(".jb-navlinks")){
      var marca = nav.querySelector("a.brand");
      var lado = document.createElement("div");
      lado.className = "jb-lado";
      var links = document.createElement("nav");
      links.className = "jb-navlinks";
      links.setAttribute("aria-label", "Navegación del sitio");

      var inicio = document.createElement("a");
      inicio.href = "/";
      inicio.textContent = "Inicio";
      links.appendChild(inicio);

      if (tipo === "articulo"){
        var saber = document.createElement("a");
        saber.href = "/pages/articulos";
        saber.textContent = "Saber";
        links.appendChild(saber);
      }

      if (marca && marca.parentNode === nav){
        nav.insertBefore(lado, marca);
        lado.appendChild(marca);
        lado.appendChild(links);
      } else {
        nav.insertBefore(links, nav.firstChild);
      }
    }

    if (tipo === "articulo"){
      var sig = document.querySelector(".jb-siguiente");
      if (sig && !sig.querySelector(".jb-salidas")){
        var volver = sig.querySelector(".jb-volver");
        if (volver){
          var caja = document.createElement("div");
          caja.className = "jb-salidas";
          volver.parentNode.insertBefore(caja, volver);
          caja.appendChild(volver);
          var ini = document.createElement("a");
          ini.className = "jb-volver";
          ini.href = "/";
          ini.innerHTML = "&#8592; Ir a la página principal";
          caja.appendChild(ini);
        }
      }
    }

    if (tipo === "indice"){
      if (!document.querySelector(".jb-cierre")){
        var cta = document.querySelector(".cta-block") || document.querySelector(".confidential-footer");
        var cierre = document.createElement("div");
        cierre.className = "jb-cierre";
        var a = document.createElement("a");
        a.href = "/";
        a.innerHTML = "&#8592; Volver a la página principal";
        cierre.appendChild(a);
        if (cta && cta.parentNode) cta.parentNode.insertBefore(cierre, cta);
        else document.body.appendChild(cierre);
      }
    }
  }

  function liberaTema(){
    var b = document.querySelector(".jb-tema");
    if (!b) return;
    var soltar = function(){
      if (typeof window.__jbSaberLibera === "function") window.__jbSaberLibera();
    };
    b.addEventListener("pointerdown", soltar, true);
    b.addEventListener("mousedown", soltar, true);
    b.addEventListener("keydown", soltar, true);
    b.addEventListener("click", soltar, true);
  }

  function arranca(){
    montaEscena();
    montaSalidas();
    liberaTema();
    marcaApariciones();
    luzDelCursor();
    respaldoApariciones();
    respaldoCine();
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", arranca);
  } else {
    arranca();
  }
})();
